import React, { Suspense, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Loader } from 'components';
import { API } from 'services/api';
import 'url-search-params-polyfill';

// import module styles
import './module.scss';
import { useQuery } from 'utils';

const AUTH_TOKEN_SESSION_KEY = 'auth_token';

const ItemsOverview = React.lazy<any>(() => import('./itemsOverview/itemOverview'));
const ProofOfDelivery = React.lazy<any>(() => import('./proofOfDelivery/proofOfDeliveryRoute'));
const ProofOfCollection = React.lazy<any>(() => import('./proofOfCollection/proofOfCollectionRoute'));
const InvoicePage = React.lazy<any>(() => import('./InvoicePage/invoicePage'));
const FineryInvoice = React.lazy<any>(() => import('./fineryInvoice/fineryInvoicePage'));
const TrustPage = React.lazy<any>(() => import('./itemsOverview/pages/trustPage'));
const Wardrobe = React.lazy<any>(() => import('./wardrobe/wardrobeRoute'));

/**
 * Modules Entry Routes
 */
const AppRoutes: React.FC = () => {
  let query = useQuery();

  // Persist token from URL to sessionStorage and set auth header; use stored token when URL no longer has it
  useEffect(() => {
    const tokenFromUrl = query.get('token');
    if (tokenFromUrl) {
      sessionStorage.setItem(AUTH_TOKEN_SESSION_KEY, tokenFromUrl);
      API.defaults.headers.common['Authorization'] = `Bearer ${tokenFromUrl}`;
      // Remove token from URL to avoid leakage (preserve other params and hash)
      const url = new URL(window.location.href);
      url.searchParams.delete('token');
      const newUrl = url.pathname + url.search + (url.hash || '');
      window.history.replaceState({}, '', newUrl);
    } else {
      const storedToken = sessionStorage.getItem(AUTH_TOKEN_SESSION_KEY);
      if (storedToken) {
        API.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
      } else {
        delete API.defaults.headers.common['Authorization'];
        window.location.href = 'https://washmen.com';
      }
    }
  }, [query]);

  return (
    <Suspense fallback={<Loader show />}>
      <Routes>
        <Route path="/" element={<ItemsOverview />} />
        <Route path="/proofOfCollection" element={<ProofOfCollection />} />
        <Route path="/proofOfDelivery" element={<ProofOfDelivery />} />
        <Route path="/receipt" element={<InvoicePage />} />
        <Route path="/finery/receipt" element={<FineryInvoice />} />
        <Route path="/trustpage" element={<TrustPage />} />
        <Route path="/wardrobe/*" element={<Wardrobe />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};
export default AppRoutes;
